"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScrollUpModule = _interopRequireDefault(require("./ScrollUp.module.css"));
var ScrollUp = function ScrollUp(props) {
  var scrolltop = function scrolltop() {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  };
  var classes = [_ScrollUpModule["default"].ScrollUp, props.className];
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: scrolltop,
    className: classes.join(' '),
    "data-testid": "ScrollUp"
  }, props.children);
};
ScrollUp.defaultProps = {
  className: ''
};
var _default = ScrollUp;
exports["default"] = _default;